export {
  CHAT_TASK_PROMPTS as LANDING_TASK_CARDS,
  type ChatTaskKind as LandingTaskKind,
  type ChatTaskPrompt as LandingTaskCard
} from './chat-behavior'

export function firstNameFromDisplayName(name?: string | null): string | undefined {
  if (typeof name !== 'string') return undefined
  const first = name.trim().split(/\s+/)[0]
  return first && first.length > 0 ? first : undefined
}

export function greetingForHour(hour: number, firstName?: string): string {
  const period = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : 'evening'
  return firstName ? `Good ${period}, ${firstName}` : `Good ${period}`
}
